export default __webpack_public_path__ + "static/media/post.f9804160.svg";